import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import { MonthlyProcessService } from '../../../service/monthly-process/monthly-process.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { AccountBookService } from '../../../service/account-book/account-book.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa8003.component.html',
  styleUrls: ['wa8003.component.css']
})
export class Wa8003Component implements AfterViewInit {
  public componentTitle = 'WA8003:月次データ確定';

  public owners: any;
  public bookyearmonths: any;

  public ownerId: number;
  public bookyearmonthTx: string;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  public stAccountBookIdThisMonth = 0;
  private errorInfo = '';

  constructor(
    private router: Router,
    private monthlyProcessService: MonthlyProcessService,
    private ownerService: OwnerService,
    private accountBookService: AccountBookService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    console.log(event.target);
  }

  ownerChange(event) {
    this.accountBookService
      .getBookYearMonth(this.ownerId, this.stAccountBookIdThisMonth)
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        console.log(JSON.stringify(outputJson.bookyearmonths));
        this.bookyearmonthTx = outputJson.bookyearmonths[0]['bookyearmonthTx'];
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    if (this.ownerId === undefined) {
      this.errorInfo = '荷主を選択してください';
      return;
    }
    this.dialogsService.confirm('確認', '確定後の修正はできません。確定してよろしいですか？').subscribe(res => {
      if (res === true) {
        this.working = true;
        this.monthlyProcessService
          .put(this.ownerId, this.bookyearmonthTx, 'WA8003')
          .then(outputJson => {
            this.working = false;
            this.ownerId = undefined;
            this.bookyearmonthTx = undefined;
            this.dialogsService.info('完了', '月次データを確定しました。');
          })
          .catch(error => {
            this.working = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8003/wa8003.component.ts